var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "max-h-[600px] overflow-y-auto" },
      [
        _c(
          "el-card",
          {
            staticClass: "box-card",
            attrs: {
              bordered: false,
              shadow: "never",
              "body-style": { padding: 0 },
            },
          },
          [
            _c(
              "el-form",
              {
                attrs: { inline: "", "label-position": "right" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品 I D ：" } },
                  [
                    _c("el-input", {
                      staticClass: "selWidth",
                      attrs: {
                        placeholder: "请输入商品ID",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.getGoodsList($event)
                        },
                      },
                      model: {
                        value: _vm.listPram.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "productId", $$v)
                        },
                        expression: "listPram.productId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品名称：" } },
                  [
                    _c("el-input", {
                      staticClass: "selWidth",
                      attrs: {
                        placeholder: "请输入商品名称，关键字",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.getGoodsList($event)
                        },
                      },
                      model: {
                        value: _vm.listPram.keywords,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "keywords", $$v)
                        },
                        expression: "listPram.keywords",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商户名称：" } },
                  [
                    _c("merchant-name", {
                      attrs: { "mer-id-checked": _vm.listPram.merId },
                      on: { getMerId: _vm.getMerId },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品分类：" } },
                  [
                    _c("el-cascader", {
                      ref: "cascader",
                      staticClass: "selWidth",
                      attrs: {
                        clearable: "",
                        options: _vm.merPlatProductClassify,
                        props: _vm.categoryProps,
                        size: "small",
                      },
                      on: { change: _vm.handleSeachList },
                      model: {
                        value: _vm.listPram.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "categoryId", $$v)
                        },
                        expression: "listPram.categoryId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品品牌：" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "selWidth",
                        attrs: {
                          clearable: "",
                          size: "small",
                          placeholder: "请选择",
                          filterable: "",
                        },
                        on: { change: _vm.handleSeachList },
                        model: {
                          value: _vm.listPram.brandId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "brandId", $$v)
                          },
                          expression: "listPram.brandId",
                        },
                      },
                      _vm._l(_vm.productBrand, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.name,
                            value: item.id,
                            disabled: !item.isShow,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: "价格区间：" } }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          size: "small",
                          placeholder: "最低",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.minPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "minPrice", $$v)
                          },
                          expression: "listPram.minPrice",
                        },
                      }),
                      _c("span", { staticClass: "mx-1" }, [_vm._v(" 至 ")]),
                      _c("el-input", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          size: "small",
                          placeholder: "最高",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.maxPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "maxPrice", $$v)
                          },
                          expression: "listPram.maxPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", { attrs: { label: "库存区间：" } }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          size: "small",
                          placeholder: "最低",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.minStock,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "minStock", $$v)
                          },
                          expression: "listPram.minStock",
                        },
                      }),
                      _c("span", { staticClass: "mx-1" }, [_vm._v(" 至 ")]),
                      _c("el-input", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          size: "small",
                          placeholder: "最高",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.maxStock,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "maxStock", $$v)
                          },
                          expression: "listPram.maxStock",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:product:page:list"],
                            expression: "['platform:product:page:list']",
                          },
                        ],
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.getGoodsList },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      { attrs: { size: "small" }, on: { click: _vm.reset } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-card",
          {
            staticClass: "box-card",
            attrs: { shadow: "never", bordered: false },
          },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                attrs: {
                  data: _vm.listData.list,
                  size: "small",
                  height: "360",
                },
                on: {
                  "select-all": _vm.handleSelectionAllChange,
                  select: _vm.handleSelectionChange,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "序号",
                    type: "index",
                    width: "50",
                    index: function (index) {
                      return (
                        (_vm.listPram.page - 1) * _vm.listPram.limit + index + 1
                      )
                    },
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "商品ID", prop: "id", "min-width": "80" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "商品名称",
                    prop: "productName",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "规格名称",
                    prop: "specName",
                    "min-width": "140",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "分类",
                    prop: "categoryName",
                    "min-width": "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "商城售价", "min-width": "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "¥ " + _vm._s(_vm.formatMoney(scope.row.price))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "成本价", "min-width": "90" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "¥ " + _vm._s(_vm.formatMoney(scope.row.cost))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "基础成本", "min-width": "90" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "¥ " + _vm._s(_vm.formatMoney(scope.row.baseCost))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "建议售价", "min-width": "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "¥ " + _vm._s(_vm.formatMoney(scope.row.otPrice))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "库存", prop: "stock", "min-width": "80" },
                }),
                _c("el-table-column", {
                  attrs: { label: "销量", prop: "sales", "min-width": "80" },
                }),
              ],
              1
            ),
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.listPram.page,
                "page-sizes": _vm.constants.page.limit,
                layout: _vm.constants.page.layout,
                total: _vm.listData.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer-inner mt-14 mb-10",
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "hasPermi",
                rawName: "v-hasPermi",
                value: ["platform:product:page:list"],
                expression: "['platform:product:page:list']",
              },
            ],
            attrs: { type: "primary" },
            on: { click: _vm.handlerSubmit },
          },
          [_vm._v(" 确定")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }